import { RootState } from '@/App/store';

export const selectGoogleAnalytics = (state: RootState) => state.config.googleAnalytics;
